import { TrackingEventCategories as BaseTrackingEventCategories } from '../../common/tracking/tracking-event-categories.model';

export const TrackingEventCategories = {
  ...BaseTrackingEventCategories,
  OPEN_DATA_TABLE_DIALOG: 'open_data_table_dialog'
};
